export class CompteurDto {
    numeroCompteur: string;
    nomFacture: string;
    constructor(numeroCompteur: string, facture: string){
        this.nomFacture = facture;
        this.numeroCompteur = numeroCompteur;
    }
}
